import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PageTitle from '../components/PageTitle';
import PageHeader from '../components/PageHeader';
import Container from '../components/story-completion/Container';
import PatternCardList from '../components/PatternCardList';
import Card from '../components/Card';
import CardTitle from '../components/CardTitle';
import CardProgress from '../components/CardProgress';
import __ from '../utils/translator';
import thronThumbnail from '../utils/thronThumbnail';
import remToPixels from '../utils/remToPixels';
import { useTheme } from 'styled-components';
import CollectionStoreActions from '../flux/CollectionStoreActions';
import CollectionStore from '../flux/CollectionStore';
import CardsLayoutPattern from "../utils/CardsLayoutPattern";
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import RenderOnTablet from '../components/responsive/RenderOnTablet';
import RenderOnMobile from '../components/responsive/RenderOnMobile';
import Header from '../components/organisms/Header';

// @todo 2021-06-11 extract
function resizeCover(cover) {
  return cover.replace('0x0', `${remToPixels(45)}x${remToPixels(45)}`);
}

function isCollectionActive(collection) {
  return new Date(collection.closedAt) > new Date();
}

export default function Seasonal({

}) {
  const theme = useTheme();
  const [collections, setCollections] = useState([]);

  useEffect(function() {
    CollectionStoreActions.all();
  }, []);

  useEffect(function() {
    const subscription = CollectionStore.addListener(() => {
      setCollections(CollectionStore.getState());
    });

    return function() {
      subscription.remove();
    }
  }, []);

  return (
    <div>
      <Header />

      <PageTitle withTracking title="Seasonal" />

      <RenderOnTablet>
        <PageHeader
          crumbs={[__('Home'), __('Seasonal')]}
          title={__('Seasonal')}
          cover={thronThumbnail(theme.pageHeaderContentId.archive)} />
      </RenderOnTablet>


      <Container>
        <SectionTitle as={themeResponsiveProperty('h4', 'h3')({ theme })}>
          {__('Active')}
        </SectionTitle>

        <PatternCardList pattern={CardsLayoutPattern.List}>
          {collections.filter(collection => isCollectionActive(collection)).map(collection => (
            <Card
              key={collection.id}
              linkTo={`seasonal/${collection.id}`}
              cover={resizeCover(collection.cover)}
            >
              <div>
                <RenderOnMobile>
                  <strong style={{ textTransform: 'uppercase', fontSize: '.75rem' }}>{__('Seasonal')}</strong>
                </RenderOnMobile>
                <CardTitle style={{ textTransform: 'uppercase', }}>{collection.name}</CardTitle>
              </div>
              <CardProgress percentage={collection.percentage} />
            </Card>
          ))}
        </PatternCardList>

        <SectionTitle as={themeResponsiveProperty('h4', 'h3')({ theme })}>
          {__('Archive')}
        </SectionTitle>

        <PatternCardList pattern={CardsLayoutPattern.List}>
          {collections.filter(collection => ! isCollectionActive(collection)).map(collection => (
            <Card
              key={collection.id}
              style={{  opacity: 0.5 }}
              linkTo={`/seasonal/${collection.id}`}
              cover={resizeCover(collection.cover)}
            >
              <CardTitle style={{ textTransform: 'uppercase', }}>{collection.name}</CardTitle>
              <CardProgress percentage={collection.percentage} />
            </Card>
          ))}
        </PatternCardList>
      </Container>
    </div>
  );
}

const SectionTitle = styled.h3`
  margin: 0;
  padding-right: 1.25rem;
  padding-left: 1.25rem;
  font-weight: bold;
`;
